import React from "react";
import Assignment from "../components/Assignment";

function Assignments() {
  return (
    <div className="page-container">
      {/* Header Image */}
      <img
        src="./assignments/Assignments_header.png"
        alt="Assignments"
        className="header-img"
      />

      <Assignment
        image="./assignments/WeeklyInspo.png"
        name="Weekly Inspirations"
        schedule="Due Date: Individual Presentation Dates"
        link="https://drive.google.com/file/d/1d-fHn2744rak64kcFEzLOrAtFHI5-NYZ/view?usp=drive_link"
        description="To keep us all up-to-date on progress in our community and to assist project teams with reviewing related work, each synlab course meeting kicks off with the presentation of inspirational project-related works by synlab course members. Every student in the synlab course must do one weekly inspiration presentation during the semester."
      />

      <Assignment
        image="./assignments/ProjectWorkplan.png"
        name="Project Workplan"
        schedule="Due Date and Presentation: February 5th"
        link="https://drive.google.com/file/d/1YF_mgcCjBYKrpj14K3Wj2CAcIIArrFw8/view?usp=drive_link"
        description="Each project team will prepare a workplan for the semester. Preparing your workplan consists of both information gathering and brainstorming/planning. As you are joining an active research lab with ongoing projects, you need to first understand the context, motivation, and research goals of your project, which includes any work on the project to date, as well as related work in the field. With this understanding, you can shape specific goals for the semester and make a plan to achieve them."
      />

      <Assignment
        image="./assignments/PaperReview.png"
        name="Paper Review"
        schedule="Due Date: February 19th"
        link="https://drive.google.com/file/d/1hNObMr1uAchDdTISMRaljClMQPgsnrsH/view?usp=drive_link"
        description="One of the most common ways for researchers to share their results with their larger (typically international) community is by writing and submitting academic papers for publication in journals and/or conference proceedings. Upon submission, these papers are usually reviewed by other researchers in the community. These reviewers provide feedback to the authors about their paper prior to publication and assess whether the paper is ready for publication. The goal of this assignment is to learn how to review an academic paper and to practice this skill by writing a review of a paper that is related to your team’s project."
      />

      <Assignment
        image="./assignments/WIP.png"
        name="Work-in-Progress"
        schedule="Due Date and Presentation: March 5th"
        link="https://drive.google.com/file/d/10IEsVyCrxYupx88Oe3xJIRi0QV81vABo/view?usp=drive_link"
        description="Each project team will present their work-in-progress (WIP) once in the middle of the semester. WIP presentations are not a presentation of final work, but rather an update on the team’s progress and also an opportunity to engage the full class in discussion, brainstorming, or testing of the team’s current ideas and progress on their project. As you prepare your WIP presentation, think about what stage your project is in, and how you might best engage the class in your project update in a way that is useful for your team."
      />

      <Assignment
        image="./assignments/FinalProject.png"
        name="Final Project"
        schedule="Due Date and Presentation: April 9th"
        link="https://drive.google.com/file/d/1j0Yi5VvyhogPe3c5t-2jnMTw4V3kppl0/view?usp=drive_link"
        description="Each team will present and demonstrate their project in the final class session. Think about how you will clearly communicate what you have done in two formats: as a slide presentation and as a live demo or a video demonstration. The final project presentation is the culmination of all your hard work this semester, so make it spectacular!"
      />

      <Assignment
        image="./assignments/FinalPaper.png"
        name="Final Paper (Grad Students)"
        schedule="Due Date: April 12th"
        link="https://drive.google.com/file/d/1Gce1vBg_YKr59ASqFZHhSSQChsmhtGPQ/view?usp=drive_link"
        description="The graduate students on each project team should prepare one short research paper to describe and reflect on their team’s work this semester. For teams with multiple graduate students, they can opt for individual short papers (max 4 pages not including references) or team-based full papers (max 8 pages not including references)."
      />
    </div>
  );
}

export default Assignments;
